import React, {useEffect, useState} from "react";
import data from "../assets/ItemTest.json";
import Item from "./components/Item";
import '../css/Home.css';
import {useDispatch,useSelector} from "react-redux";
import {AddCart} from "./reducer";
import firebase from "firebase";
import AddCartCircle from "./components/AddCartCircle";
import Detail from "./components/Detail";

const Contents=()=>{
    const db = firebase.firestore();
    const dispatch = useDispatch();
    const [cartItem,setCartItem]=useState([]);
    const [itemList,setItemList]=useState([]);
    const [detail,setDetail]=useState();
    const [modal,setModal]=useState(false);
    const [quan,setQuan]=useState(1);
    let item =useSelector(state => state.add_cart);
    useEffect(()=>{
        if(item){
            setCartItem(item)
        }
    },[])
    useEffect(()=>{
        dispatch(AddCart(cartItem))
    },[cartItem])
    useEffect(()=>{
        db.collection('product').get().then((res)=>{
            let arr = []
            res.forEach((doc)=>{
                let data = doc.data();
                arr.push(data)
            })
            arr.sort((a,b)=>{
                return new Date(b.date)-new Date(a.date)
            })
            setItemList(arr)
        })

    },[])
    return(
        <>
            {modal&&
                <Detail
                    item={detail}
                    setModal={setModal}
                    quan={quan}
                    setQuan={setQuan}
                    cartItem={cartItem}
                    setCartItem={setCartItem}/>
            }
            <AddCartCircle number={cartItem.length}/>
            <div className={'flex__center'}>
                <div className={"contents-title-background-box"}>
                    <div className={'red-dot-box'}>
                        <div className={'red-dot'}/>
                    </div>
                    <h3>상품소개</h3>
                </div>
                <div className={"flex__low flex__space-between"}>
                    {
                        itemList&&
                        itemList.map(item=>(
                            <Item
                                key={item.name}
                                src={item.url}
                                price={item.price}
                                title={item.name}
                                setDetail={setDetail}
                                setModal={setModal}
                                explan={item.explan}
                                suburl={item.suburl}
                                option={item.option}
                            />
                        ))
                    }
                </div>
            </div>
        </>
    );
}

export default Contents
